<template>
  <!-- Common Set Password Component-->
  <div class="setPassword" data-qa="setpassword-div-k19ox">
    <v-layout wrap data-qa="setpassword-layout-kd7ndf">
      <v-flex data-qa="setpassword-flex-joj39">
        <v-form ref="resetPasswordForm" v-model="formValid" class="pa-4 pr-0 py-0" data-qa="setpassword-form-rrqoc3">
          <v-flex v-if="config.enableLoginId" xs12 sm12 md12 lg8 xl8 class="pa-1" data-qa="setpassword-flex-votvin">
            <font class="subtitle-1 font-weight-medium pb-2">{{
              $t("registerUser.createLoginID")
            }}</font>
            <v-text-field
              v-model="loginID"
              @blur="checkLoginID"
              :label="$t('registerUser.loginIDPlaceholder')"
              :color="primaryColor"
              :rules="[rules.required, rules.loginIdMinlength]"
              :error="errorLogin"
              :error-messages="errorMessage"
              :append-icon="appendIcon"
              filled
              background-color="#f0eff7"
              name="loginID"
              data-qa="loginID"
              class="custom-textfield textFieldHighlighter"
            />
          </v-flex>
          <v-flex v-if="config.enableUserId" xs12 sm12 md12 lg8 xl8 class="pa-1" data-qa="setpassword-flex-3cv53n">
            <font v-if="!config.enableOldPassword" class="subtitle-1 font-weight-bold">{{
              $t("registerUser.userID")
            }}</font>
            <v-text-field
              v-model="config.userID"
              :label="$t('registerUser.userIDPlaceholder')"
              :color="primaryColor"
              :disabled="true"
              filled
              name="userID"
              data-qa="userID"
              class="custom-textfield textFieldHighlighter"
            />
          </v-flex>
          <v-flex v-if="config.enableOldPassword" xs12 sm12 md12 lg8 xl8 class="pa-1" data-qa="setpassword-flex-prwrsg">
            <v-text-field
              v-model="oldPassword"
              :label="config.enableOldPassword
                ? $t('changePassword.oldPassword')
                : $t('registerUser.oldPassword')
              "
              :color="primaryColor"
              filled
              name="oldPassword"
              data-qa="oldPassword"
              class="custom-textfield textFieldHighlighter"
            />
          </v-flex>
          <v-flex xs12 sm12 md12 lg8 xl8 class="pa-1 pb-2" data-qa="setpassword-flex-c6harf">
            <!-- <font class="subtitle-1 font-weight-medium">{{
            $t("settings.changePassword.newPasswordLabel")
          }}</font> -->
            <v-text-field
              v-model="newPassword"
              @input="publishUpdatedPassword"
              @click:append="showNewPasswordVal = !showNewPasswordVal"
              :color="primaryColor"
              :label="config.enableOldPassword
                ? $t('changePassword.newPassword')
                : $t('settings.changePassword.newPasswordPlaceHolder')"
              :append-icon="
                newPassword
                  ? showNewPasswordVal
                    ? 'mdi-eye'
                    : 'mdi-eye-off'
                  : ''
              "
              :type="showNewPasswordVal ? 'text' : 'password'"
              :rules="resetError ? [rules.required, rules.password, rules.minlength] : []"
              :maxlength="$appSettings.defaultConfigurations.loginPageScreens.passwordMaxLength"
              :minlength="$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength"
              :error="
                resetError ? newPassword && oldPassword === newPassword : false
              "
              :error-messages="
                resetError
                  ? newPassword && oldPassword === newPassword
                    ? $t('settings.changePassword.sameOldNewPassword')
                    : ''
                  : ''
              "
              filled
              background-color="#f0eff7"
              class="textFieldHighlighter"
              onCopy="return false"
              onpaste="return false"
              data-qa="newPassword"
            />
          </v-flex>
          <v-flex xs12 sm12 md12 lg8 xl8 class="pa-2" data-qa="setpassword-flex-yaai8v">
            <v-row justify="center" class="pa-0" data-qa="setpassword-row-jnuped">
              <v-col class="pl-4 pt-0" data-qa="setpassword-col-h3vl2j">
                <PasswordPolicyChecker :config="'PASSWORD_POLICY'" />
              </v-col>
            </v-row>
          </v-flex>

          <v-flex xs12 sm12 md12 lg8 xl8 class="pa-1" data-qa="setpassword-flex-buu4f8">
            <!-- <font class="subtitle-1 font-weight-medium">{{
            $t("settings.changePassword.renewPasswordLabel")
          }}</font> -->
            <v-text-field
              v-model="renewPassword"
              @input="publishUpdatedPassword"
              @click:append="showRenewPasswordVal = !showRenewPasswordVal"
              :error="
                resetError && renewPassword
                  ? renewPassword && newPassword !== renewPassword
                  : false
              "
              :error-messages="
                resetError && renewPassword
                  ? renewPassword && newPassword !== renewPassword
                    ? $t('settings.changePassword.passwordMismatch')
                    : ''
                  : ''
              "
              :color="primaryColor"
              :label="config.enableOldPassword
                ? $t('changePassword.confirmNewPassword')
                : $t('settings.changePassword.renewPasswordPlaceHolder')"
              :append-icon="
                renewPassword
                  ? showRenewPasswordVal
                    ? 'mdi-eye'
                    : 'mdi-eye-off'
                  : ''
              "
              :type="showRenewPasswordVal ? 'text' : 'password'"
              :rules="resetError ? [rules.required, rules.password, rules.minlength] : []"
              :maxlength="$appSettings.defaultConfigurations.loginPageScreens.passwordMaxLength"
              :minlength="$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength"
              filled
              background-color="#f0eff7"
              class="textFieldHighlighter"
              onCopy="return false"
              onpaste="return false"
              data-qa="renewPassword"
            />
          </v-flex>
        </v-form>
        <v-flex class="pa-0 ml-2 mt-2" xs12 sm12 md12 lg8 xl8 data-qa="setpassword-flex-0wsf3v">
         <v-card elevation="1" class="px-4 ml-1 py-3" data-qa="setpassword-card-3jvbuf">
          <v-card-title class="px-0 py-1" data-qa="setpassword-card-title-4yg66i">{{ $t("otp.toolBarTitle") }}</v-card-title>
          <p data-qa="setpassword-p-xdhrqq">
            <font class="subtitle-2 font-weight-regular">{{ $t("otp.securityMsg") }}</font>
          </p>
          <v-flex xl10 lg11 data-qa="setpassword-flex-m9e67">
            <OtpInput :otpConfig="otpSettings"/>
          </v-flex>
         </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-flex lg8 xl8 class="mt-7" data-qa="setpassword-flex-0o42ws">
      <v-card-actions class="ml-1" data-qa="setpassword-card-actions-3r74m5">
        <v-spacer data-qa="setpassword-spacer-ts0hwm"></v-spacer>
        <v-btn
          @click="onSave"
          :color="primaryColor"
          :disabled="!validOtpLength || (resetError ? !formValid || !isPasswordValid : true)"
          :outlined="config.outlinedPwdBtn || false"
          :rounded="config.roundedPwdBtn || false"
          :min-width="(config.roundedPwdBtn ? 135 : '') || ''"
          data-qa="savePassword"
          class="text-capitalize white--text py-2 px-4"
          >{{ config.btnLabel }}</v-btn
        >
      </v-card-actions>
    </v-flex>
  </div>
</template>

<script>
import '@/styles/components/setPassword.scss'
import event from '@/util/event'
import preload from '@/util/preload'
import policies from '@/../mocks/passwordPolicies.json'
import OtpInput from '@/components/common/PreLoginOtpInput.vue'

export default {
  name: 'SetPassword',
  components: {
    OtpInput,
    PasswordPolicyChecker: () =>
      import('@/components/DOB-Login/ResetPassword/PasswordPolicyChecker.vue')
  },
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      policies,
      oldPassword: '',
      newPassword: '',
      renewPassword: '',
      loginID: '',
      to: null,
      formValid: false,
      isPristine: false,
      isLeavingRoute: false,
      errorLogin: false,
      errorMessage: undefined,
      refresh: true,
      resetError: false,
      isResetComplete: false,
      showOTPScreen: false,
      isPasswordValid: false,
      showOldPasswordVal: false,
      showNewPasswordVal: false,
      showRenewPasswordVal: false,
      enableOTP: this.$appSettings.defaultConfigurations
        .enableOTPForResetPassword,
      otpSettings: {
        resetPasswordTime: 6000,
        flex: 'xs12 sm12 md12 lg12 xl12',
        fromScreen: this.config.fromScreen
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400,
          userLoginId: ''
        }
      },
      passwordRegEx: '',
      appendIcon: '',
      rules: {
        required: (value) => !!value || 'Required.',
        password: (value) => {
          const pattern = new RegExp(this.passwordRegEx)
          return pattern.test(value) || "Password complexity isn't matched"
        },
        loginIdMinlength: (value) => value.length >= this.$appSettings.defaultConfigurations.loginPageScreens.usernameMinLength || this.$t('registerUser.loginIdMinLength', { minLen: this.$appSettings.defaultConfigurations.loginPageScreens.usernameMinLength }),
        minlength: (value) => value.length >= this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength || this.$t('registerUser.loginIdMinLength', { minLen: this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength })
      },
      validOtpLength: false,
      otpData: undefined
    }
  },
  async created () {
    await this.setPasswordRules()
    event.$on('OTP_RESENT', (arg) => {
      this.modalConfig.otp.enableSave = true
    })
    event.$on('resetPasswordFailed', () => {
      this.resetScreen()
      event.$emit('resetPasswordPolicies')
    })
    event.$on('POLICY_CHECK', (arg) => {
      this.isPasswordValid = !arg?.disableNext
    })
    event.$on('prelogin_otp_valid_length', args => {
      this.validOtpLength = args
    })
    event.$on('prelogin_otp_data_ready', (args) => {
      if (this.fromScreen === 'changePassword') {
        this.otpData = {
          otp: args.otp,
          userLoginId: args.userLoginId
        }
      } else {
        this.otpData = {
          emailId: args.emailId,
          mobileCountryCode: args.mobileCountryCode,
          mobilePhoneNumber: args.mobilePhoneNumber,
          otp: args.otp,
          referenceNumber: args.referenceNumber
        }
      }
    })
  },
  mounted () {
    this.otpSettings.userLoginId = this.config.userID
    this.fromScreen = this.config ? this.config.fromScreen : ''
    event.$emit('fetchUserLoginId', {
      userLoginId: this.config.userID,
      oldPassword: this.oldPassword
    })
    event.$on('verifiedLoginID', (action) => {
      if (action) {
        this.checkIconToLoginID()
        this.appendIcon = 'mdi-checkbox-marked-circle green--text'
      } else {
        this.appendIcon = 'mdi-close-circle red--text'
        this.errorMessage = this.$t('registerUser.failureLoginID')
      }
    })
    switch (this.fromScreen) {
      case 'forgotPassword':
        if (this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.enableOTP) event.$emit('SEND_OTP', true)
        break
      case 'activateUser':
        if (this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.enableOTP) event.$emit('SEND_OTP', true)
        break
      case 'changePassword':
        if (this.$appSettings.defaultConfigurations.loginPageScreens.changeExpiredOrTempPassword.enableOTP) event.$emit('SEND_OTP', true)
        break
    }
  },
  methods: {
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
    },
    checkLoginID () {
      this.$parent.formMethods({ e: this.loginID, action: 'loginID' })
    },
    checkIconToLoginID () {
      this.appendIcon = ''
      this.errorMessage = ''
    },
    publishUpdatedPassword () {
      this.resetError = true
      event.$emit('PASSWORD_UPDATE', {
        new: this.newPassword,
        renew: this.renewPassword
      })
    },
    async setPasswordRules () {
      const regEx = this.$store.getters['profileStore/profileData'].passwordRegEx
      if (!regEx) {
        await this.getPasswordRules()
      } else {
        this.passwordRegEx = regEx
      }
    },
    async getPasswordRules () {
      if (this.$appSettings.authConfigurations.enableB2C) {
        await preload.getPasswordComplexity()
        const regEx = this.$store.getters['profileStore/profileData'].passwordRegEx
        if (regEx) {
          this.passwordRegEx = regEx
        }
      } else {
        this.passwordRegEx = this.policies.regex
      }
    },
    onSave () {
      if (this.formValid && this.otpData) {
        this.resetPassword()
      }
    },
    resetPassword () {
      if (this.$appSettings.authConfigurations.enableB2C) {
        event.$emit('resetPwdSuccess', {
          otpData: this.otpData,
          status: true,
          password: this.newPassword,
          loginID: this.loginID,
          oldPassword: this.oldPassword
        })
        //   const passwordPayload = {
        //     authenticationMethod: 'OTP',
        //     channelMode: 'WEB',
        //     newPassword: this.newPassword,
        //     userLoginId: JSON.parse(sessionStorage.getItem('username'))
        //   }
        //   const saveStatus = await CommonService.resetPassword(passwordPayload)
        //   if (saveStatus && saveStatus.message === 'Success') {
        //     this.isResetComplete = true
        //     this.showResetSuccessMsg()
        //   } else {
        //     this.showResetFailureMsg()
        //   }
        // } else {
        //   this.isResetComplete = true
        //   this.showResetSuccessMsg()
      } else {
        event.$emit('resetPwdSuccess', {
          status: true,
          password: this.newPassword,
          loginID: this.loginID,
          oldPassword: this.oldPassword
        })
      }
    },
    resetScreen () {
      this.$refs.resetPasswordForm.resetValidation()
      this.newPassword = ''
      this.oldPassword = ''
      this.renewPassword = ''
      this.resetError = false
      this.formValid = false
      this.isPasswordValid = false
      this.showOldPasswordVal = false
      this.showNewPasswordVal = false
      this.showRenewPasswordVal = false
      event.$emit('resetPasswordPolicies')
    },
    showResetSuccessMsg () {
      if (this.config.showSuccessModal) {
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: this.$t('settings.changePassword.modalTitle'),
            width: 400,
            persistent: true,
            saveButton: this.$t('common.okay'),
            saveCallback: this.resetScreen,
            content: this.$t('settings.changePassword.resetPasswordSuccess'),
            type: 'success',
            component: 'dob-modal'
          }
        })
      } else {
        event.$emit('resetPwdSuccess', {
          status: true,
          password: this.newPassword
        })
      }
    },
    showResetFailureMsg () {
      if (this.config.showSuccessModal) {
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: this.$t('settings.changePassword.modalTitle'),
            width: 400,
            persistent: true,
            saveButton: this.$t('common.okay'),
            saveCallback: this.resetScreen,
            content: this.$t('settings.changePassword.resetPasswordFailure'),
            type: 'error',
            component: 'dob-modal'
          }
        })
      } else {
        event.$emit('resetPwdSuccess', false)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
  }
}
</script>

<style lang="scss" scoped>
.textFieldHighlighter {
  .v-text-field > .v-input__control > .v-input__slot:before {
    border-color: $defaultBorderColor !important;
    border-style: solid;
    border-width: 0.5px;
  }
}
</style>
